export const environment = {
  production: true,
  serverUrl: 'https://plwd238pc5.execute-api.eu-north-1.amazonaws.com/Prod'
  // serverUrl: 'https://46g3v1nw4g.execute-api.eu-north-1.amazonaws.com/Prod'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts